import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export default function LanguageSwitcher({ dark = false }) {
  const { lang, setLang } = useI18n();
  const base = "px-2.5 py-1 text-xs font-semibold uppercase tracking-wider transition-colors rounded";
  const active = dark ? "bg-brand-orange text-white" : "bg-brand-navy text-white";
  const idle = dark ? "text-white/70 hover:text-white" : "text-slate-500 hover:text-brand-navy";
  return (
    <div className={`inline-flex items-center gap-1 rounded-md ${dark ? "bg-white/10" : "bg-slate-100"} p-0.5`} data-testid="lang-switcher">
      <button
        className={`${base} ${lang === "fr" ? active : idle}`}
        onClick={() => setLang("fr")}
        data-testid="lang-fr"
      >
        FR
      </button>
      <button
        className={`${base} ${lang === "en" ? active : idle}`}
        onClick={() => setLang("en")}
        data-testid="lang-en"
      >
        EN
      </button>
    </div>
  );
}
